<!-- Mark Invoice Modal -->
<div class="modal fade" id="markInvoiceModal" msEscClose
	(escPressed)="onCancel()"
	data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="markInvoiceModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">

			@if (isPaidAction) {
				<div class="fs-5 border-0 p-4">
					<div class="fw-semibold">Invoice #{{ charge()?.propertyChargeId }}</div>
					@if (charge()?.propertyTitle) {
						<div class="text-muted">{{ charge()?.propertyTitle }}</div>
					}
				</div>
			}

			<div class="modal-body" [class.px-4]="isPaidAction" [class.text-center]="!isPaidAction">

				@if (!isPaidAction) {
					<fa-duotone-icon icon="circle-question" class="confirmation-icon text-info" />

					<div class="pt-4 px-4" [innerHTML]="voidConfirmationMessage()"></div>
				}

				<form [formGroup]="markForm" (keydown.enter)="$event.preventDefault()"
					[class.px-4]="!isPaidAction" [class.text-start]="!isPaidAction" [class.py-0]="!isPaidAction">

					<!-- Payment Type (Paid only) -->
					@if (isPaidAction) {
						<ms-input-label [isRequired]="isFieldRequired(markForm, 'paymentType')" [labelText]="'Payment Type'" />
						<select
							id="paymentType"
							formControlName="paymentType"
							class="form-select"
							[class.is-invalid]="markForm.get('paymentType')?.invalid && markForm.get('paymentType')?.touched"
							[class.is-valid]="markForm.get('paymentType')?.valid && markForm.get('paymentType')?.touched">
							<option [value]="ManualPaymentType.Check">Check</option>
							<option [value]="ManualPaymentType.Cash">Cash</option>
							<option [value]="ManualPaymentType.Card">Credit Card</option>
							<option [value]="ManualPaymentType.ACH">ACH</option>
							<option [value]="ManualPaymentType.Other">Other</option>
						</select>
						@if (markForm.get('paymentType')?.invalid && markForm.get('paymentType')?.touched) {
							<div class="error-messages">
								@if (markForm.get('paymentType')?.errors?.['required']) {
									<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.MarkInvoicePaymentTypeRequired }}</p>
								}
							</div>
						}

						<!-- Check Number (only when paymentType === Check) -->
						@if (isCheckPayment) {
							<ms-input-label [labelText]="'Check Number'" class="mt-3" />
							<input
								type="text"
								id="checkNumber"
								formControlName="checkNumber"
								maxlength="30"
								class="form-control"
								[class.is-invalid]="markForm.get('checkNumber')?.invalid && markForm.get('checkNumber')?.touched"
								[class.is-valid]="markForm.get('checkNumber')?.valid && markForm.get('checkNumber')?.touched && markForm.get('checkNumber')?.value !== ''" />
							@if (markForm.get('checkNumber')?.invalid && markForm.get('checkNumber')?.touched) {
								<div class="error-messages">
									@if (markForm.get('checkNumber')?.errors?.['maxlength']) {
										<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.MarkInvoiceCheckNumberMaxLength }}</p>
									}
									@if (markForm.get('checkNumber')?.errors?.['pattern']) {
										<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.MarkInvoiceCheckNumberPattern }}</p>
									}
								</div>
							}
						}

						<!-- Payment Received Date -->
						<ms-input-label [labelText]="'Payment Date'" class="mt-3" />
						<input
							type="date"
							id="paymentReceivedDate"
							formControlName="paymentReceivedDate"
							class="form-control"
							[class.is-invalid]="markForm.get('paymentReceivedDate')?.invalid && markForm.get('paymentReceivedDate')?.touched"
							[class.is-valid]="markForm.get('paymentReceivedDate')?.valid && markForm.get('paymentReceivedDate')?.touched" />
						@if (markForm.get('paymentReceivedDate')?.invalid && markForm.get('paymentReceivedDate')?.touched) {
							<div class="error-messages">
								@if (markForm.get('paymentReceivedDate')?.errors?.['noFutureDate']) {
									<p class="text-danger text-start pt-1 mb-0">{{ markForm.get('paymentReceivedDate')?.errors?.['noFutureDate'].message }}</p>
								}
							</div>
						}

						<!-- Deposit Account (read-only — assigned by the system, never selected here) -->
						@if (stripeBalanceAccount(); as balanceAccount) {
							<ms-input-label [labelText]="'Deposit Account'" class="mt-3" />
							<div class="fw-semibold">{{ balanceAccount.accountNumber }} - {{ balanceAccount.name }}</div>
						}
					}

					<!-- Notes (both actions) -->
					<ms-input-label [labelText]="'Notes'" class="mt-3" />
					<textarea
						id="note"
						formControlName="note"
						maxlength="500"
						rows="3"
						class="form-control"
						[class.is-valid]="markForm.get('note')?.valid && markForm.get('note')?.touched && markForm.get('note')?.value !== ''">
					</textarea>
					@if (markForm.get('note')?.errors?.['maxlength'] && markForm.get('note')?.touched) {
						<div class="error-messages">
							<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.MarkInvoiceNoteMaxLength }}</p>
						</div>
					}

					<!-- Send Email Checkbox -->
					<div class="form-check mt-3">
						<input
							type="checkbox"
							id="sendEmail"
							formControlName="sendEmail"
							class="form-check-input" />
						<label class="form-check-label" for="sendEmail">
							Send email notification
						</label>
					</div>
				</form>
			</div>

			<div class="modal-footer border-0 d-flex justify-content-center pb-4">
				<button type="button" class="btn btn-ms-secondary" (click)="onCancel()">
					Cancel
				</button>
				<button type="button" class="btn btn-primary"
					(click)="onSubmit()">
					@if (isSubmitting) {
						<div class="spinner-border text-light spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					} @else {
						{{ isPaidAction ? 'Mark as Paid' : 'Mark as Void' }}
					}
				</button>
			</div>

		</div>
	</div>
</div>

<!-- Confirmation Modal -->
<ms-confirmation-modal #markInvoiceConfirmationRef modalId="markInvoiceConfirmationModal"
	(confirmed)="confirmSubmit()"
	(cancelled)="confirmationCancelled()" />

<!-- Info Modal -->
<ms-info-modal #markInvoiceInfoRef modalId="markInvoiceInfoModal"
	(onConfirm)="infoModalConfirmed()" />

<!-- Esc Confirmation Modal -->
<ms-confirmation-modal
	#markInvoiceEscConfirmationRef
	modalId="markInvoiceEscConfirmationModal"
	confirmButtonText="Leave"
	cancelButtonText="Stay"
	(confirmed)="onEscConfirmed()"
	(cancelled)="onEscCancelled()"
/>
